module.exports = __webpack_public_path__ + "static/media/shortTextphone2.fb73aef4.svg";